import { Card, Container, Row, Table } from 'react-bootstrap';
import styled from 'styled-components';

export const CareerContainer = styled(Container)`
      padding: 3rem;

      @media screen and (max-width: 600px) {
            padding: 2rem 15px;
      }
`;

export const CareerRow = styled(Row)`
      justify-content: center;
      align-items: center;
`;

export const CareerItem = styled.div`
      padding: 20px;
      border: 1px solid ${(props) => props.theme.borderColor};
      border-radius: 5px;
      background-color: #f2f2f2;
`;

export const CareerHeader = styled.div`
      display: flex;
      justify-content: space-between;
      width: 100%;
      background-color: #f2f2f2;
      padding: 10px;
      border-radius: 5px;

      a {
            display: block;
            text-decoration: none;

            &:hover + div {
                  color: ${(props) => props.theme.primaryColor};
            }
      }

      @media screen and (max-width: 600px) {
            justify-content: left;
            display: block;
            padding: 0;
      }
`;

export const CareerHeaderImage = styled.div`
      display: flex;
      gap: 20px;

      div {
            font-weight: 600;
            font-size: 18px;
            letter-spacing: 0.5px;
            width: calc(100% - 60px);
            color: ${(props) => props.theme.black} !important;

            div {
                  &:last-child {
                        font-size: 16px;
                        color: #666 !important;
                  }
            }
      }
      img {
            width: 60px;
            background-color: ${(props) => props.theme.white};
            border: 1px solid ${(props) => props.theme.borderColor};
      }
`;

export const CareerHeaderIcon = styled.div`
      display: flex;
      gap: 10px;

      div {
            margin-top: 2.5px;
            font-size: ${(props) => props.fontSize};
            font-weight: ${(props) => props.fontWeigth};
      }

      @media screen and (max-width: 600px) {
            display: none;
      }
`;

export const CareerBody = styled.div`
      p {
            font-size: 16px;
            margin-top: 10px;
            text-align: justify;
            font-weight: 500;
      }
`;

export const CareerLink = styled.div`
      width: 100%;
      margin-top: 20px;

      a {
            background-color: ${(props) => props.theme.primaryColor};
            color: ${(props) => props.theme.white};
            padding: 10px 16px;
            display: block;
            text-align: center;
            width: fit-content;

            &:hover {
                  background-color: ${(props) => props.theme.secondaryColor};
            }
      }
`;

export const CareerCard = styled(Card)`
      background-color: #f2f2f2;
      border: 1px solid #ced4da;
      color: #515151;
      padding: 16px;

      label {
            font-size: 18px;
      }

      input,
      select,
      textarea {
            border-radius: 0;
      }

      select:focus {
            box-shadow: none;
      }
`;

export const CareerTitle = styled.div`
      border-bottom: 1px solid #ced4da;
      font-size: 18px;
      font-weight: 600;
      padding-bottom: 10px;
      padding-top: 10px;
`;

export const CareerTable = styled(Table)`
      strong {
            font-size: 24px;
      }

      td {
            font-size: 16px;
      }

      ul {
            li {
                  list-style: disc !important;
            }
      }
`;
